import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
    breakpoint: {
        thresholds: {
            xs: 600,
            sm: 960,
            md: 1280,
            lg: 7680, // Change break point at @/sass/variables.scss
        }
    },
    theme: {
        dark: true,
        themes: {
            light: {
                primary: '#7f552f',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
            },
            dark: {
                primary: '#e5c15d',
                secondary: '#CCA889',
                accent: '#EEEEEE',
                error: '#FF5252',
                info: '#82B1FF',
                success: '#58CC5C',
                warning: '#FFC107',
                background: '#121212',
                // 'lit-background': '#262626'
            },
        },
        options: {
            customProperties: true,
        }
    }
});
